



















































































































































































































































































































































































































































































































































































































































































































/** @format */

import { Component, Vue, Prop, Watch, Mixins } from 'vue-property-decorator';
import BdSwitch from '@/components/bd-switch';
import TableMixin from '@/common/mixins/table';
import TableWidthMixin from '@/common/mixins/table-width';
import { cloneDeep } from 'lodash';
import AddByTime from './components/add-by-time.vue';
import moment from 'moment';
import {
  IByTimeMainForm,
  byTimeMainFormDefault,
  IByTimeBackUpForm,
  byTimeBackUpFormDefault,
  IOnOnceForm,
  normalForm
} from './type';

@Component({
  components: { BdSwitch, AddByTime }
})
export default class BillingOnTime extends Mixins(TableMixin, TableWidthMixin) {
  // @Prop({
  //   type: String,
  //   default: '',
  // })
  // datePattern!: string

  @Prop()
  normalForm!: IOnOnceForm;
  // normalForm!: IByTimeMainForm
  //  = byTimeMainFormDefault
  @Prop()
  holidayForm!: IOnOnceForm;
  // byTimeBackUpForm!: IByTimeBackUpForm
  // = byTimeBackUpFormDefault
  @Prop({
    type: Boolean,
    default: true
  })
  disabled!: boolean;

  mounted() {
    this.normalForm.rules.length = 2;
    console.log(this.normalForm, 'hahahha=---------->');
    this.showMoreGet();
  }
  created() {
    this.showMoreGet();
  }

  activated() {
    this.showMoreGet();
  }

  // 回显展开
  showMoreGet() {
    if (this.normalForm && this.normalForm.moreflag === true) {
      this.moreflag = this.normalForm.moreflag;
    }
    if (this.normalForm && this.normalForm.getmoreflag === true) {
      this.getmoreflag = this.normalForm.getmoreflag;
    }
  }

  moment = moment;

  tableData = [];
  isvisible = false;
  moreflag = false;
  getmoreflag = false;
  showmore() {
    this.moreflag = !this.moreflag;
  }
  showgetmore() {
    this.getmoreflag = !this.getmoreflag;
  }
  // 是否是外层的table
  isTableNum = '';
  newFlerRules = [];
  // 添加阶梯费率 展示弹框
  showModeVisible(val) {
    console.log(val, '------->');
    this.isTableNum = val;
    this.isvisible = true;
    if (val === 'abc') {
      this.newFlerRules = this.normalForm.billingOnFreeTimes;
    } else {
      // console.log(this.normalForm, val, '111111111----------2222222222============')
      if (!this.normalForm.rules[val].billingOnFreeTimes) {
        // console.log('11111--------->>>>>>>')
        this.normalForm.rules[val].billingOnFreeTimes = [];
      }
      this.newFlerRules = this.normalForm.rules[val].billingOnFreeTimes;
    }
  }
  closeModeVisible() {
    this.isvisible = false;
  }
  // 删除table 外层 中的一行
  toDeleteWai(row) {
    console.log(row, '0000000');
    this.normalForm.billingOnFreeTimes = this.normalForm.billingOnFreeTimes.filter(item => item.id !== row.id);
  }
  // 删除table 内层 中的一行
  toDeleteNei(row, num) {
    console.log(row);
    this.normalForm.rules[num].billingOnFreeTimes = this.normalForm.rules[num].billingOnFreeTimes.filter(
      item => item.id !== row.id
    );
  }
  submitOK(values, num) {
    console.log(values, num, '添加进去--------->');
    if (num === 'abc') {
      // 外层table
      this.normalForm.billingOnFreeTimes = [...this.normalForm.billingOnFreeTimes, values];
    } else {
      this.normalForm.rules[num].billingOnFreeTimes = [...this.normalForm.rules[num].billingOnFreeTimes, values];
    }
    this.closeModeVisible();
  }
  // 添加分段
  addsubsection() {
    // this.$emit('addsubsection')
    try {
      this.normalForm.rules.push({
        startTime: moment('00:00', 'HH:mm'),
        endTime: moment('00:00', 'HH:mm'),
        freeTime: 0,
        includedFreeTime: '0',
        topMoneyOfSection: 0,
        isPremiumRateSwitch: '0',
        startChargeTime: 0,
        startChargeMoney: 0,
        cycleChargeTime: 0,
        cycleChargeMoney: 0,
        billingOnFreeTimes: []
      });
    } catch (e) {
      console.log(e);
    }
  }
  delsubsection() {
    try {
      if (this.normalForm.rules.length > 2) {
        this.normalForm.rules.pop();
      } else {
        this.$message.warning('最少要有两段');
      }
    } catch (e) {
      console.log(e);
    }
  }
  handleStarTimeChange(val, index) {
    console.log(val, index, '9990000----0098990------>>>>');
    if (index === 0) {
      this.normalForm.rules[1].endTime = val;
    }
  }
  handleEndTimeChange(val, index) {
    console.log(val, index, '9990000----0098990------>>>>');
    if (index === 0) {
      this.normalForm.rules[1].startTime = val;
    }
  }
  // 按时计费111
  addbyTimeMain() {
    try {
      console.log('00');
    } catch (e) {
      console.log(e);
    }
  }
  delbyTimeMain(index) {
    try {
      console.log(11);
    } catch (e) {
      console.log(e);
    }
  }
  labelCol: any = {
    xs: { span: 4 },
    sm: { span: 4 }
  };
  wrapperCol: any = {
    xs: { span: 12 },
    sm: { span: 12 }
  };
  labelCol1: any = {
    xs: { span: 6 },
    sm: { span: 6 }
  };
  labelCol2: any = {
    xs: { span: 8 },
    sm: { span: 8 }
  };
  labelCol3: any = {
    xs: { span: 5 },
    sm: { span: 5 }
  };
  labelCol99: any = {
    xs: { span: 4 },
    sm: { span: 4 }
  };
  wrapperCol99: any = {
    xs: { span: 4 },
    sm: { span: 4 }
  };
  labelCol66: any = {
    xs: { span: 8 },
    sm: { span: 8 }
  };
  wrapperCol66: any = {
    xs: { span: 1 },
    sm: { span: 1 }
  };

  // 表字段说明
  get tableColums() {
    return [
      // {
      //   title: '序号',
      //   width: 100,
      //   customRender: (text: any, record: any, index: number) => `${(this.current - 1) * this.pageSize + index + 1}`,
      // },
      {
        // title: '起始（分钟）',
        dataIndex: 'startTime',
        width: 140,
        slots: { title: 'customTitle' },
        scopedSlots: { customRender: 'startTime' }
        // scopedSlots: { customRender: 'text-ellipse-to-tip' },
      },
      {
        // title: '结束（分钟）',
        dataIndex: 'endTime',
        width: 140,
        slots: { title: 'customTitle1' }
      },
      {
        // title: '单位时长（分钟）',
        dataIndex: 'oneTime',
        width: 170,
        slots: { title: 'customTitle2' }
      },
      {
        // title: '单位金额（元）',
        dataIndex: 'money',
        width: 160,
        slots: { title: 'customTitle3' }
      },
      {
        // title: '最高限额（元）',
        dataIndex: 'highMoney',
        width: 160,
        scopedSlots: { customRender: 'plate' },
        slots: { title: 'customTitle4' }
      },
      {
        // title: '累加规则',
        dataIndex: 'rule',
        width: 160,
        slots: { title: 'customTitle5' },
        // scopedSlots: { customRender: 'rule' },
        customRender: function(val: any) {
          if (val === '0') {
            return '每次停车执行一次';
          } else if (val === '1') {
            return '多次停车时长累加';
          } else if (val === '2') {
            return '一天或时段内仅执行一次';
          } else {
            return '';
          }
        }
      },
      {
        title: '操作',
        dataIndex: 'operation',
        fixed: 'right',
        width: 100,
        scopedSlots: { customRender: 'operation' }
      }
    ];
  }
}
